import axios from 'axios'

export default async function getModelMember(path, Model, query = {}) {
  return axios
    .get(`${path}.json`, { params: { query } })
    .then(({ data }) => {
      const instance = new Model(data[Model.singularCamelFullName])
      return { ...data, [Model.singularCamelFullName]: instance }
    })
    .catch((e) => {
      console.log("getModelMember error: ", e)
      console.log(`${path}.json`)
      return { error: true }
    });
}
